"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingNotificationType = void 0;
let ShoppingNotificationType = exports.ShoppingNotificationType = /*#__PURE__*/function (ShoppingNotificationType) {
  ShoppingNotificationType["Error"] = "Error";
  ShoppingNotificationType["Info"] = "Info";
  ShoppingNotificationType["Reminding"] = "Reminding";
  ShoppingNotificationType["Success"] = "Success";
  ShoppingNotificationType["Warning"] = "Warning";
  return ShoppingNotificationType;
}({});
